// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ReleaseChannel,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  pinKey: __t.string().name("pin_key"),
  orgId: __t.string().name("org_id"),
  project: __t.string(),
  appId: __t.string().name("app_id"),
  get channel() {
    return ReleaseChannel;
  },
  pinnedVersionId: __t.option(__t.u64()).name("pinned_version_id"),
  autoUpdate: __t.option(__t.bool()).name("auto_update"),
  updatedAt: __t.timestamp().name("updated_at"),
  updatedBy: __t.identity().name("updated_by"),
});
